import BaseButton from '../../../../components/BasicComponent/BaseButton'
import BaseInput from '../../../../components/BasicComponent/BaseInput'
import DraggableScroll from '../../../../components/BasicComponent/DraggableScroll'
import FixedBottom from '../../../../components/BasicComponent/FixedBottom'
import { IconVehicleMoto } from '../../../../assets/icons'
import { sanitizePlateInput } from '../../../../helper/validatorPlateNumber'

function RemoveIcon() {
  return (
    <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="1.4" />
      <path d="M7 7 13 13M13 7l-6 6" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  )
}

export default function Layout2({
  plateInput,
  setPlateInput,
  setPlateError,
  plateError,
  blurTimeoutRef,
  viewportHeightBeforeKeyboardRef,
  getViewportHeight,
  setIsPlateInputFocused,
  setIsVirtualKeyboardOpen,
  handleAddVehicleFromInput,
  suggestedVehicles,
  selectedVehicles,
  addVehicle,
  SuggestionVehicleIcon,
  selectedCount,
  maxVehicles,
  getVehicleTypeInfo,
  handleRemoveVehicle,
  shouldHideContinueButton,
  isContinueDisabled,
  openConfirmPopup,
  handleContinue
}) {
  return (
    <>
      <div className="TrafficFineNotificationVehicles">
        <div className="TrafficFineNotificationVehicles_addCard">
          <div className="TrafficFineNotificationVehicles_subtitle">Thêm xe mới</div>
          <div className="TrafficFineNotificationVehicles_inputRow">
            <BaseInput
            value={plateInput}
            onChange={(event) => {
              const value = sanitizePlateInput(event.target.value)
              setPlateInput(value)
              setPlateError('')
            }}
            showClear={Boolean(plateInput)}
            onClear={() => {
              setPlateInput('')
              setPlateError('')
            }}
            onFocus={() => {
              if (blurTimeoutRef.current) {
                window.clearTimeout(blurTimeoutRef.current)
                blurTimeoutRef.current = null
              }

              viewportHeightBeforeKeyboardRef.current = getViewportHeight()
              setIsPlateInputFocused(true)
            }}
            onBlur={() => {
              blurTimeoutRef.current = window.setTimeout(() => {
                setIsPlateInputFocused(false)
                setIsVirtualKeyboardOpen(false)
                viewportHeightBeforeKeyboardRef.current = 0
                blurTimeoutRef.current = null
              }, 180)
            }}
            placeholder="Nhập biển số xe"
            error={plateError}
          />
            <BaseButton
              className="TrafficFineNotificationVehicles_addButtonBottom"
              disabled={!plateInput}
              onClick={handleAddVehicleFromInput}>
              Thêm
            </BaseButton>
          </div>
        </div>

        {suggestedVehicles.length > 0 ? (
          <div className="TrafficFineNotificationVehicles_suggestions">
            <DraggableScroll>
              <div className="TrafficFineNotificationVehicles_suggestionsTrack">
                {suggestedVehicles.map((vehicle) => {
                  const isSelected = selectedVehicles.some((selectedVehicle) => selectedVehicle.plate === vehicle.plate)

                  return (
                    <button
                      key={`${vehicle.plate}-${vehicle.vehicleType}`}
                      type="button"
                      className={`TrafficFineNotificationVehicles_suggestionItem ${
                        isSelected ? 'TrafficFineNotificationVehicles_suggestionItem_active' : ''
                      }`.trim()}
                      onClick={() => {
                        if (!isSelected) {
                          addVehicle(vehicle.plate)
                        }
                      }}>
                      <SuggestionVehicleIcon className="TrafficFineNotificationVehicles_suggestionIcon" />
                      <span>{vehicle.plate}</span>
                    </button>
                  )
                })}
              </div>
            </DraggableScroll>
          </div>
        ) : null}

        <div className="TrafficFineNotificationVehicles_listHeader">Danh sách xe đã chọn ({selectedCount})</div>

        <div className="TrafficFineNotificationVehicles_list">
          {selectedVehicles.map((vehicle) => {
            const vehicleTypeInfo = getVehicleTypeInfo(vehicle.vehicleType)
            const SelectedVehicleIcon = vehicleTypeInfo?.IconComponent || IconVehicleMoto

            return (
              <div key={`${vehicle.plate}-${vehicle.vehicleType}`} className="TrafficFineNotificationVehicles_vehicleItem">
                <div className="TrafficFineNotificationVehicles_vehicleInfo">
                  <SelectedVehicleIcon className="TrafficFineNotificationVehicles_vehicleIcon" />

                  <div className="TrafficFineNotificationVehicles_vehicleText">
                    <div className="TrafficFineNotificationVehicles_vehiclePlate">{vehicle.plate}</div>
                    <div className="TrafficFineNotificationVehicles_vehicleType">{vehicleTypeInfo?.label}</div>
                  </div>
                </div>

                <button
                  type="button"
                  className="TrafficFineNotificationVehicles_removeButton"
                  onClick={() => handleRemoveVehicle(vehicle.plate, vehicle.vehicleType)}
                  aria-label={`Xóa xe ${vehicle.plate}`}>
                  <RemoveIcon />
                </button>
              </div>
            )
          })}
        </div>
      </div>

      {!shouldHideContinueButton ? (
        <FixedBottom elementPaddingBottom="LayoutPartner">
          <BaseButton
            disabled={isContinueDisabled}
            onClick={() => {
              if (selectedCount < maxVehicles) {
                openConfirmPopup({
                  title: `Bạn chưa chọn đủ ${maxVehicles} xe`,
                  content: 'Sau khi thanh toán, bạn sẽ không thể thêm hoặc thay đổi xe. Bạn có muốn tiếp tục không?',
                  onConfirm: handleContinue
                })
                return
              }

              handleContinue()
            }}>
            Tiếp theo
          </BaseButton>
        </FixedBottom>
      ) : null}
    </>
  )
}
